import React from 'react'
import { Switch, withStyles } from '@material-ui/core'
import colors from '../../assets/colors'

export const CustomSwitch = withStyles(theme => ({
  root: {
    width: 40,
    height: 20,
    padding: 0,
  },
  switchBase: {
    padding: 2,
    '&$checked': {
      transform: 'translateX(20px)',
      color: theme.palette.common.white,
      '& + $track': {
        backgroundColor: colors.primary,
        opacity: 1,
        border: 'none',
      },
    },
    '&$focusVisible $thumb': {
      color: colors.primary,
      border: '6px solid #fff',
    },
  },
  thumb: {
    width: 16,
    height: 16,
    boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.2)',
  },
  track: {
    borderRadius: 32 / 2,
    border: `1px solid ${theme.palette.grey[400]}`,
    backgroundColor: theme.palette.grey[300],
    opacity: 1,
    transition: theme.transitions.create(['background-color', 'border']),
  },
  checked: {},
  focusVisible: {},
}))(({ classes, ...props }) => {
  return (
    <Switch
      focusVisibleClassName={classes.focusVisible}
      disableRipple
      classes={{
        root: classes.root,
        switchBase: classes.switchBase,
        thumb: classes.thumb,
        track: classes.track,
        checked: classes.checked,
      }}
      {...props}
    />
  )
})
